import { render, staticRenderFns } from "./TargetsConfig.vue?vue&type=template&id=44476d52&scoped=true&"
import script from "./TargetsConfig.vue?vue&type=script&lang=js&"
export * from "./TargetsConfig.vue?vue&type=script&lang=js&"
import style0 from "./TargetsConfig.vue?vue&type=style&index=0&lang=css&"
import style1 from "./TargetsConfig.vue?vue&type=style&index=1&id=44476d52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44476d52",
  null
  
)

component.options.__file = "TargetsConfig.vue"
export default component.exports